const base = '/helper',
    basePath = `pages${base}`;
export default [
    {
        path:`${base}/option`,
        name:'helperOption',
        component:r => require.ensure([], () => r(require(`@/${basePath}/option`)), 'helperOption'),
        meta:{
            tit:'安装说明'
        }
    },
    {
        path:`${base}/faq`,
        name:'helperFaq',
        component:r => require.ensure([], () => r(require(`@/${basePath}/faq`)), 'helperFaq'),
        meta:{
            tit:'常见问题'
        }
    }
]


// WEBPACK FOOTER //
// ./src/router/router/helper.js